import { useRoutes } from "react-router";
import Login from "../pages/Login";

import Pay from "../pages/Pay";
import Personal from "../pages/Personal";
import MyOrder from "../pages/Personal/MyOrder";
import InvoiceManagement from "../pages/Personal/InvoiceManagement";
import All from "../pages/Personal/InvoiceManagement/All";
import Title from "../pages/Personal/InvoiceManagement/Title";
import Address from "../pages/Personal/InvoiceManagement/Address";
import App from "../App";
import Result from "../pages/Result";
import WaitResult from "../pages/WaitResult";
import Alipay from "../pages/Success/Alipay";
import AllInPay from "../pages/Success/AllInPay";
import PayMent from "@/pages/PayMent";
import RegistrationForm from "@/pages/RegistrationForm";
import RegistrationManagement from "../pages/Personal/RegistrationManagement";
import ResultPage from "../components/Result";
import Authorization from "@/pages/Authorization";
import UpgradePage from "@/pages/UpgradePage";

const Routes = () => {
  const routers = useRoutes([
    // {
    //   path: "*",
    //   element: <UpgradePage />,
    // },
    {
      path: "/upgrade",
      element: <UpgradePage />,
    },
    // 登录
    {
      path: "/login",
      element: <Login />,
    },
    {
      path: "/",
      element: <App />,
    },
    {
      path: "/success/alipay",
      element: <Alipay />,
    },
    {
      path: "/success/all-in-pay",
      element: <AllInPay />,
    },
    {
      path: "/result",
      element: <Result />,
    },
    {
      path: "/payment",
      element: <PayMent />,
    },
    // 免密支付
    {
      path: "/authorization",
      element: <Authorization />,
    },
    {
      path: "/personal",
      element: <Personal />,
      children: [
        // { index: true, element: <MyOrder /> },
        {
          path: "order",
          element: <MyOrder />,
        },
        {
          path: "invoice",
          element: <InvoiceManagement />,
          children: [
            {
              path: "all",
              element: <All />,
            },
            {
              path: "title",
              element: <Title />,
            },
            {
              path: "address",
              element: <Address />,
            },
          ],
        },
        // {
        //   path: "registration",
        //   element: <RegistrationManagement />,
        // },
      ],
    },
    {
      path: "/wrap/wait-result/:transaction_id",
      element: <WaitResult />,
    },
    {
      path: "/pay-gateway",
      element: <Pay />,
    },
    {
      path: "/pay",
      element: <Pay />,
    },
    {
      path: "/meeting",
      element: <Pay />,
    },
    {
      path: "/book",
      element: <Pay />,
    },
    {
      path: "/ppv",
      element: <Pay />,
    },
    {
      path: "/registration",
      element: <RegistrationForm />,
    },
    {
      path: "/registrationResult",
      element: <ResultPage />,
    },
    {
      path: "*",
      element: <Login />,
    },
  ]);

  return routers;
};
export default Routes;
